module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-collector-1.9fa1adf9.svg";